import ImageSlider from "../../components/ImageSlider/ImageSlider";
import { withAppHOC } from "../../hoc";

const Home = () => {
  return <ImageSlider images={["/slider-01.png", "/slider-02.png"]} />;
};

export default withAppHOC(Home);
